module.exports = __webpack_public_path__ + "static/media/pink-slider2.9fcd3954.jpg";